export class MobileMoneyOut {
  type: string = "MOBILE_MONEY"
  operator_id: string = "orange_money"
  identifier: string = ""
}
